/**
 * Include your custom JavaScript here.
 * 
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



$( document ).on( "click", ".product-additional-atc", function() {
  var ID = $(this).attr("data-productid"); 
  if(ID){ 
    addItemToCart( ID, 1 );    // paste your id product number
  }
});


$('.triggerit').trigger( "click" );


function addItemToCart(variant_id, qty ) {
  data = {
    "id": variant_id,
    "quantity": qty
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {  
        bubbles: true  //this code is for prestige theme, is to refresh the cart
      })); 
      
      setTimeout(function(){   
        $("#sidebar-cart").attr( "aria-hidden", "false" );
        $("#sidebar-cart").attr( "tabindex", "-1" );
        $(".PageOverlay").addClass('is-visible');
        $(".Drawer__Close").addClass('custom_close');
      }, 1000);  
    }   
    
  }); 
  
}

$("body").on("click", ".custom_close", function () {
  $("#sidebar-cart").attr( "aria-hidden", "true" );
  $("#sidebar-cart").removeAttr( "tabindex");
  $(".PageOverlay").removeClass('is-visible');
  $(this).removeClass('custom_close');
}); 

// Event start working when atc clicked
 document.addEventListener('product:added', function(event) {
   var variant = event.detail.variant; // Get the variant that was added
   var quantity = event.detail.quantity; // Get the quantity that was added
   var targetProduct = $('.first-releventProduct').attr('data-product'); // get the first recommended product handle 
    setTimeout(function(){ // to make some delay so reload will not work at same time
      if(targetProduct){
        window.location.replace(
          targetProduct
        );
      }
    }, 1000);
 });
/* Function to get query string from the URl */
  function getQueryStringParameters() {
    var parameters = {}, hash;
    var q = document.URL.split('?')[1];
    if(q !== undefined) {
      q = q.split('&');
      for(var i = 0; i < q.length; i++) {
        hash = q[i].split('=');
        parameters[hash[0]] = hash[1];
      }
    }
    return parameters;
  }
  function isEmpty(obj) {
    for(var key in obj) {
      if(obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }
var parameters = getQueryStringParameters();
if(isEmpty(parameters) === false) {
  $.each(parameters, function(key, value) {
    if(key === 'product' && value !=''){
      var pvalue = decodeURIComponent(value);
      console.log(pvalue);

      let targetProduct = window.location.href;
      targetProduct = targetProduct.replace("https://floot.shop/products/","");
      if(targetProduct.includes("?")){
  
      targetProduct = targetProduct.split("?");
      targetProduct = targetProduct[0];
        
      }


      


        
      if (targetProduct.includes("ohrring")){

      pvalue = "Hier noch ein passender Ohrring für Dich";  

      if(targetProduct.includes("stecker")){

      pvalue = "Hier noch ein passender Ohrring Stecker für Dich";
        
      }

      if(targetProduct.includes("cuff")){

      pvalue = "Hier noch ein passender Cuff Ohrring für Dich";
        
      }
        
      if(targetProduct.includes("huggie")){

      pvalue = "Hier noch ein passender Huggie Ohrring für Dich";
        
      }

         if(targetProduct.includes("ohrring-anhanger")){

      pvalue = "Hier noch ein passender Ohrring Anhänger für Dich";
        
      }


      }


      if (targetProduct.includes("-ring-")){

      pvalue = "Hier noch ein passender Ring für Dich";
        
      }

      if (targetProduct.includes("halsketten-anhanger")){

      pvalue = "Hier noch eine passender Halsketten Anhänger für Dich";
        
      }


      

      if (targetProduct.includes("-halskette-")){

      pvalue = "Hier noch eine passende Halskette für Dich";
        
      }

      
      if (targetProduct.includes("armband")){

      pvalue = "Hier noch ein passendes Armband für Dich";
        
      }

       if (targetProduct.includes("fusskette")){

      pvalue = "Hier noch eine passende Fußkette für Dich";
        
      }

    

      if (targetProduct.includes("shirt")){

      pvalue = "Hier noch ein passendes T-Shirt für Dich";
        
      }


      
      $("<div class='product-recommend-announcement'><h2 class='product-recommend-h2'>"+pvalue+"</h2><div>").insertBefore(".ProductMeta__Title");
    }
  });
  
}